import { v4 as uuid } from 'uuid';
import { VatRate } from './Settings.js';
export var TaxAuthorityType;
(function (TaxAuthorityType) {
    TaxAuthorityType["verifactu"] = "verifactu";
})(TaxAuthorityType || (TaxAuthorityType = {}));
export class CountryTaxConfiguration {
    id;
    countryCode = null;
    simplifiedInvoiceTresholds = [];
    vatRates = [];
    taxAuthority = null;
    allowInvoicesForOnlinePayments = false;
    allowInvoicesForOfflinePayments = false;
    allowInvoicesWithoutTaxAuthority = false;
    constructor(id, data) {
        if (id && typeof id == 'string') {
            this.id = id;
        }
        else if (id && typeof id == 'object' && typeof id.id == 'string') {
            this.id = id.id;
        }
        else {
            this.id = uuid();
        }
        if (id && typeof id == 'object') {
            data = id;
        }
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        if (key == 'taxAuthority') {
                            value = value;
                        }
                        if (key == 'vatRates' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new VatRate(item.id, item));
                            }
                            value = items;
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
export class SimplifiedInvoiceTreshold {
    id;
    limit = null;
    name = null;
    isDefault = false;
    constructor(id, data) {
        if (id && typeof id == 'string') {
            this.id = id;
        }
        else if (id && typeof id == 'object' && typeof id.id == 'string') {
            this.id = id.id;
        }
        else {
            this.id = uuid();
        }
        if (id && typeof id == 'object') {
            data = id;
        }
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
